export default "__VITE_ASSET__XMIwWEqf__"